import { Button, Dialog, DialogContent, DialogTitle } from '@e2n/ui';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { useApiAktivierung } from '../hooks/useApiAktivierung';

type DeaktivierenDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function DeaktivierenDialog({
  open,
  onOpenChange,
}: DeaktivierenDialogProps) {
  const { t } = useTranslation();
  const { setzeAktiv, loading } = useApiAktivierung();

  async function handleConfirm() {
    if (await setzeAktiv(false)) {
      onOpenChange(false);
      return;
    }

    toast.error(t('domain.e2nApi.zugaenge.deaktivierenDialog.fehler'));
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex flex-col gap-6 p-8 sm:max-w-[444px]">
        <DialogTitle>
          {t('domain.e2nApi.zugaenge.deaktivierenDialog.title')}
        </DialogTitle>

        <div className="text-sm text-neutrals-900">
          {t('domain.e2nApi.zugaenge.deaktivierenDialog.description')}
        </div>

        <div className="flex items-center justify-end gap-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('domain.e2nApi.zugaenge.deaktivierenDialog.abbrechen')}
          </Button>
          <Button onClick={handleConfirm} disabled={loading}>
            {t('domain.e2nApi.zugaenge.deaktivierenDialog.bestaetigen')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
